import React from 'react';
import { useRootFileMetadata } from 'js/file_viewer/api/data';
import { useFileViewerContext } from 'js/file_viewer/contexts/file_viewer';
import { useSetLocalErrorCallback } from 'js/file_viewer/core/atoms/error';
import { useCurrentPreviewMetadata } from 'js/file_viewer/core/queries/preview_metadata';
import { ErrorLifecycle, FVError, FVErrorCode } from 'js/file_viewer/core/types/errors';
import { isFVError } from 'js/file_viewer/core/utils/errors';
import { getFileExtension } from 'js/file_viewer/core/utils/paths';
import { useStabilizedCallback } from 'js/file_viewer/core/utils/useStabilizedCallback';
import { useRootPreviewKey } from 'js/file_viewer/hooks/selectors';
class UnconnectedErrorBoundary extends React.PureComponent {
    componentDidCatch(error) {
        this.props.onError(error);
    }
    static getDerivedStateFromError() {
        return {};
    }
    render() {
        return this.props.children;
    }
}
UnconnectedErrorBoundary.displayName = "UnconnectedErrorBoundary";
export const ErrorBoundary = ({ children }) => {
    var _a;
    const previewKey = useRootPreviewKey();
    const previewMetadata = useCurrentPreviewMetadata();
    const fileMetadata = useRootFileMetadata();
    const fileExtension = getFileExtension(fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.file_name);
    const reportException = (_a = useFileViewerContext().optionalIOClients.reportExceptionClient) === null || _a === void 0 ? void 0 : _a.reportException;
    const setLocalErrorCallback = useSetLocalErrorCallback(previewKey);
    const onError = useStabilizedCallback((error) => {
        var _a;
        reportException === null || reportException === void 0 ? void 0 : reportException(error, ((_a = previewMetadata === null || previewMetadata === void 0 ? void 0 : previewMetadata.content) === null || _a === void 0 ? void 0 : _a['.tag']) || 'other', fileExtension, 'critical');
        setLocalErrorCallback(isFVError(error)
            ? error
            : new FVError(FVErrorCode.Unknown, ErrorLifecycle.Render, error.message));
    });
    return React.createElement(UnconnectedErrorBoundary, { onError: onError }, children);
};
ErrorBoundary.displayName = "ErrorBoundary"
//# sourceMappingURL=error_boundary.preenvesnextjs.map
